<script>
import { addToSessionStore, getFromSessionStore, delFromSessionStore } from './modules/sessionStore'
import { getGrant, getClientContext, openClientContext, closeClientContext, openChildPanel, addRootMenu, delRootMenu, httpRequest, openMenuItem, getContacts, getMeetings } from './modules/sessions'
import { sendAlert } from './modules/alerts'
import { createList, getListData } from './modules/listManager'
import { getSettings, setSettings, cleanPhoneSetting, setPhoneState, getRoleSettings, requestSettings, getSettingsHistory } from './modules/settings'
import CallManager from './modules/callManager'
import ClientManager from './modules/clientManager'
import BotManager from './modules/botManager'
import { watch, ref, nextTick } from 'vue'
import { botContext } from './stores/botContext'
import { Subject } from 'rxjs';
import { fromEvent } from 'rxjs';
import IVRManager from './modules/ivrManager'
import { injectIntoIframe, injectIntoWebComponent } from './modules/elmentsLoader.js';

export default {
  data() {
    return {
      initTime : new Date(),
      dateTime : null,
      subjects : [],
      callManager : new CallManager(),
      clientManager : new ClientManager(),
      botManager : new BotManager(),
      botEvents : {},
      ivrManager : new IVRManager({})
    }
  },
  methods: {
    systemInfo : function () {
      if(window.ReactNativeWebView) {
        return "Android App"
      } else {
        return "Browser App"
      }
    },
    botLogs : function(log) {
      let dateTime = new Date();
      let timeDiff = 0;
      if(this.dateTime) {
        timeDiff = (dateTime - this.dateTime);
      }
      this.dateTime = dateTime;
      let tduration = (dateTime - this.initTime);
     //console.log("[DateTime : ",dateTime, "]", "[PrgsvTime : ",timeDiff,"]", "[TotalTime : ",tduration,"] Log : ", log);
    },
    addSubscriber : function(subject) {
      let index = this.subjects.findIndex((subjectinfo) => subjectinfo.id == subject.id);
      if(index != -1) {
        this.subjects.psuh(subject);
      }
    },
    delSubscriber : function(subject) {
      let index = this.subjects.findIndex((subjectinfo) => subjectinfo.id == subject.id);
      if(index != -1) {
        this.subjects.splice(index, 1);
      }
    },
    openClient : function(params, callback) {
      console.log("OpenClient Got : ", params);
      if(params.ClientRowID) {
        window.BotServices.Events.next({ViewPorts : [params]});
      }
      let activeClient = window.devStore.getActiveClient;      
      if(params.ContainerID) {
        window.botStore.addContainer(params);
      }
    },
    openTermination : function(termination) {
      console.log("Open Termination", termination);
    },
    closeClient : function(params, callback) {
     //console.log("closeClient got : ", params);
      closeClientContext(params, callback);
    },
    openChildPanel : function(params, callback) {
      openChildPanel(params, callback);
    },
    PullRootMenu : function(params, callback) {
     //console.log("PullRootMenu Got : ", params);
      if(window.devStore.isLanding) {
        window.devStore.setLanding(false);
        //document.getElementById("dmoverlay").style.display = "block";
      }
      if (callback && (typeof callback == "function")) {
        openMenuItem(params, callback);
      } else {
        openMenuItem(params, ()=>{});
      }      
    },
    PullClient : function(params, rootMenu) {
     //console.log("PullClient Got : ", params);
      params.HistoryID = window.LivingScript_0070.guid.generateSync(); 
      this.botStore.addContext(params);
      if(params.clientNodeId && rootMenu.Path) {
        window.devStore.updateRootMenu({ClientRowID : params.clientNodeId, Path : rootMenu.Path});
      }
    },
    PullViewPort : function(params, rootMenu) {
     //console.log("PullViwPort Got : ", params);
      window.devStore.addViewPort(params);
      if(params.viewportID && rootMenu.Path) {
        window.devStore.updateRootMenu({ViewPortID : params.viewportID, Path : rootMenu.Path});
      }
      window.devStore.AddToPanelStack(params.viewportID);
    },
    PullTermination : function(params, rootMenu) {
     //console.log("PullTermination Got : ", params);
      window.devStore.addTerminationPoint(params);
      if(params.terminationID && rootMenu.Path) {
        window.devStore.updateRootMenu({TerminationID : params.terminationID, Path : rootMenu.Path});
      }
    },
    PullPE : function(params, callback) {
     //console.log("PullPE Got : ", params);
      openClientContext(params, callback);
    },
    RemoveTermination : function(terminationID, rootMenu) {
      console.log("RemoveTermination", terminationID);
      window.devStore.delTerminationPoint({terminationID : terminationID});
      window.devStore.updateRootMenu({ResetTermination : true, Path : rootMenu.Path});
    },
    ActiveViewport(viewportId) {
      /*
      if(window.botStore.settings['ActiveViewport'] && window.botStore.settings['ActiveViewport'] == viewportId) {
        //console.log("Skip ActiveViewport");
      } else {
        window.botStore.setSettings({name : 'ActiveViewport', value : viewportId});
        if(window.oxygenUtil && window.oxygenUtil.putViewportOnTop) {
          window.oxygenUtil.putViewportOnTop(viewportId);
        }
      }*/
    },
    ShowClient : function(ClientID) {
      let rootMenu = window.devStore.getRootMenuByClient(ClientID);
      if(rootMenu) {
        this.PullRootMenu(rootMenu);
      }
    },
    RegisterClientDoc : function(params, callback) {
      this.clientManager.registerYjsClient(params, callback);
    },
    WriteClientDoc : function(params, callback)  {
      this.clientManager.writeToYjsDoc(params, callback);
    },
    GetClientChannel : function(ClientID) {
      if(this.clientManager.events[ClientID]) {
        return this.clientManager.events[ClientID];
      } else {
        return null;
      }
    },
    CreateList : function(params, callback) {
     //console.log("Create List API Got", params);
      createList(params, callback);
    },
    GetListData : function(params, callback) {
      getListData(params, callback);
    },
    BotInit : function(params, callback) {
      this.botManager.initSessionsBot(params, callback);
    },
    AwakenComponent : function(componentId, callback) {
      this.botManager.awakenComponent(componentId, callback);
    },
    BotConnect : function(params, callback) {
     //console.log("BotConnect", params);
      this.botManager.initBot(params, callback);
    },
    BotReload : function(params, callback) {
     //console.log("BotReload", params);
      this.botManager.reloadBot(params, callback);
    },
    BotSend : function(params, callback) {
     //console.log("BotSend", params);
      this.botManager.botSend(params, callback);
    },
    BotRequest : function(params, callback) {
      this.botManager.requestSessionsBot(params, callback);
    },
    /* Rxjs Channel For Client */
    getClientChannel : function(ClientID) {
      return this.clientManager.getRxjsClient(ClientID);
    },
    ExecDesk : function(params, callback) {
      this.clientManager.execDesk(params, callback);
    },
    exportCommands : function(params) {
     //console.log("exportCommands : ", params);
      if(params.appId) {
        window.botStore.addCommands(params);
      }
    },
    retractCommands : function(params) {
      if(params.appId) {
        window.botStore.delCommands(params);
      }
    },
    addHeadderIcon : function(params) {
      if(params.appId) {
        window.botStore.addHeadderIcon(params);
      }
    },
    delHeadderIcon : function(params) {
      if(params.appId) {
        window.botStore.delHeaderIcon(params);
      }
    },
    httpRequest : function(params, callback) {
      httpRequest(params, callback);
    },
    sendAlert : function(params) {
      sendAlert(params);
    },
    openAlert : function(params, callback) {
      this.clientManager.OpenAlert(params, callback);
    },
    callManagerInit : function(params) {
      this.callManager.init(params);
    },
    clientManagerInit : function(params) {
      this.clientManager.init(params, ()=>{});
    },
    callManagerApi : function(params) {
      if(params.action && this.callManager[params.action]) {
        this.callManager[params.action](params.data);
      }
    },
    callManagerExec : function(params, callback) {
      if(callback && typeof callback == 'function') {
      } else {
        callback = () => {};
      }
      if(params.mode == 'send') {
        this.callManager.sendSMS(params, callback);
      } else if(params.mode == 'join'){
        this.callManager.joinMeeting(params);
      } else if(params.mode == 'preview') {
        this.callManager.previewCall(params, callback);
      } else if(params.mode == 'operator') {
        this.callManager.operatorCall(params, callback);
      } else if(params.mode == 'connect') {
        this.callManager.connectCall(params);
      } else if(params.mode == 'getmeeting') {
        this.callManager.getMeetingContext(params, callback);
      } else if(params.mode == 'email'){
        this.callManager.sendEmail(params, callback);
      } else if(params.mode == 'graph') {
        this.callManager.sendGraph(params, callback);
      } else {
        this.callManager.makeCall(params, callback);
      }
    },
    callManagerGetStates : function(ClientID) {
      return this.callManager.getCallStates(ClientID);
    },
    callComponent : function(params, callback) {
      if(params.clientId) {
        this.clientManager.callComponentClient(params.clientId, params.componentId, params.containerId, params.command, params.data, params.Type, callback);
      } else {
        this.clientManager.callComponent(params.componentId, params.containerId, params.command, params.data, params.Type, callback);
      }
    },
    startCall : function(params) {
      this.callManager.startCall(params);
    },
    stopCall : function(params) {
      this.callManager.stopCall(params);
    },
    stopMedia : function(params) {
      this.callManager.stopPublisherMedia(params);
    },
    muteMedia : function(params) {
      this.callManager.muteMedia(params);
    },
    unmuteMedia : function(params) {
      this.callManager.unmuteMedia(params);
    },
    endCall : function(params) {
      this.callManager.endCall(params);
    },
    endParticipant : function(params) {
      this.callManager.endParticipant(params);
    },
    answerCall : function(params) {
      this.callManager.answerCall(params);
    },
    rootMenuApi : function(params, callback) {
      if(params.Action == 'addRootMenu') {
        addRootMenu(params.Data, callback);
      } else if(params.Action == 'delRootMenu') {
        delRootMenu(params.Data, callback);
      }
    },
    peSettings : function (params, callback) {
      if(params.Action == 'getSettings') {
        getSettings(params.Data, callback);
      } else if(params.Action == 'setSettings') {
        setSettings(params.Data, callback);
      } else if(params.Action == 'setPhoneState'){
        setPhoneState(params.Data, callback);
      } else if(params.Action == 'requestSettings') {
        requestSettings(params.Data, callback);
      } else if(params.Action == 'getSettingsHistory') {
        getSettingsHistory(params.Data, callback);
      } else if(params.Action == 'cleanPhoneSetting') {
        cleanPhoneSetting(params.Data, callback);
      } else if(params.Action == 'getRoleSettings') {
        getRoleSettings(params.Data, callback);
      }
    },
    commState : function (params, callback) {
     //console.log("commState got : ", params);
      this.callManager.CommStates(params, callback);
    },
    settings : function (params, callback) {
      if(params.Action == 'getSettings') {
        getSettings(params.Data, callback);
      } else if(params.Action == 'getSettings') {
        setSettings(params.Data, callback);
      }
    },
    getContacts : function(params, callback) {
      getContacts(params, callback);
    },
    getMeetings : function(params, callback) {
      getMeetings(params, callback);
    },
    getBotEventChannel : function(params) {
      if(this.botEvents[params.EventName]) {
        return this.botEvents[params.EventName];
      } else {
        return null;
      }
    },
    addClientCommand(params, callback) {
      this.clientManager.addCommand(params, callback);
    },
    subscribeToEvents(params, callback) {
     //console.log("subscribeToEvents : ", params);
      if(params.ClientID && params.EventType == 'CallManager') {
        this.callManager.callaManagerEvents.subscribe({
          next: ((event) => {
            if(event.ClientID == params.ClientID) {
              callback(null, event);
            }
          }),
        });
      }
    },
    callManagerEvents(params, callback) {
     //console.log("callManagerEvents : ", params);
      if(params.ClientID && params.EventType == 'CallManager') {
        this.callManager.callaManagerEvents.subscribe({
          next: ((event) => {
            if(event.ClientID == params.ClientID) {
              callback(null, event);
            }
          }),
        });
      }
    },
    getPublisherStates(ClientID) {
      if(ClientID) {
        return this.callManager.getPublisherStates(ClientID);
      } else {
        return {};
      }
    },
    initIvrBot(){
      //this.ivrManager.init(()=>{});
    },
    startIvrBot(exten, ivr) {
      this.ivrManager.startIvr(exten, ivr);
    },
    startSpeech() {
      this.ivrManager.startCapture();
    },
    stopSpeech() {
      this.ivrManager.stopCapture();
    }, 
    botChat(params, callback) {
     //console.log("botChat Req got : ", params);
      this.clientManager.chatGpt(params, callback);
    },
    /* AI api's */
    aiPublish(params, callback) {
      if(params.ClientID) {
        this.clientManager.aiPublish(params);
        callback(null, "Data Published");
      } else {
        callback("Invalic ClientID", null);
      }
    },
    getAiChannel(ClientID) {
      if(ClientID) {
        return this.clientManager.getAiChannel(ClientID);
      } else {
        return null;
      }
    },
    /* Get Shared Lik */
    getMeetingLink(ClientID, callback) {
      this.clientManager.getMeetingURL(ClientID, callback);
    },
    /* resize windows */
    resize(event) {
      this.clientManager.resize(event);
    }
  },
  mounted: function () {
    //this.botLogs("Bot Services Mounted");
    //console.log("Bot Services Mounted");
    //console.log("Time Check Created BotApp Mounted : ", new Date().getTime(), location);
    this.$nextTick(function () {
      this.ivrManager.init(()=>{});
    })
  },
  setup () {
    const botStore = botContext();
    //window.botStore = botStore;
    const contexts = ref(botStore.contexts);
    const containers = ref(botStore.containers);
    const clients = ref(botStore.clients);
    const headerIcons = ref(botStore.headerIcons);
    const commands = ref(botStore.commands);
    const streams = ref(botStore.streams);
    const meetings = ref(botStore.meetings);
    const attributions = ref(botStore.attributions);
    const proxy = {};
    const dynamicEl = [];

    /* Watch Contexts Store For Changes */
    watch(() => [...contexts.value], (newContexts, oldContexts) => {
      //console.log("Old Context: ", JSON.stringify(oldContexts), "New Context: ", JSON.stringify(newContexts));
      let diffContexts = newContexts.filter(context => !oldContexts.includes(context));
      if(diffContexts) {
       //console.log("ContextObj Added");
        window.BotServices.Events.next({Contexts : diffContexts});
        window.BotServices.EventsQueue.next({Event : 'WatchContext', Data : diffContexts});
        window.BotServices.ruleEvents(JSON.parse(JSON.stringify({Contexts : diffContexts})));
        regWebContext(diffContexts);
      } else {
       //console.log("ContextObj Removed");
      }
      addToSessionStore({item : 'contexts'});
    });

    /* Watch Container Store For Changes */
    watch(() => [...containers.value], (newContainers, oldContainers) => {
     //console.log("Old : ", JSON.stringify(oldContainers), "New : ", JSON.stringify(newContainers));
      let diffContainers = newContainers.filter(container => !oldContainers.includes(container));
      //window.BotServices.Events.next({Containers : diffContainers});
      if(window.botStore.settings && window.botStore.settings.SmartView == 'true') {
        if(window.DevMgr && window.DevMgr.openSmartPanel) {
          window.DevMgr.openSmartPanel(diffContainers);
        }
      } else {
        createWebComponent(diffContainers);
      }
    });

    /* Watch Clients Store For Changes */
    watch(() => [...clients.value], (newClients, oldClients) => {
      let diffClients = newClients.filter(client => !oldClients.includes(client));
      window.BotServices.Events.next({Clients : diffClients});
    });

    /* Watch Header Icons Store For Changes */
    watch(() => [...headerIcons.value], (newIcons, oldIcons) => {
      let diffIcons = newIcons.filter(icon => !oldIcons.includes(icon));
      window.BotServices.Events.next({HeaderIcons : diffIcons});
    });

    /* Watch Commands Store For Changes */
    watch(() => [...commands.value], (newCommads, oldCommands) => {
      let diffCommands = newCommads.filter(apps => !oldCommands.includes(apps));
     //console.log("Command Store Changed for : ", diffCommands);
      createProxy(diffCommands);
    });

    /* Watch Streams Store For Changes */
    watch(() => [...streams.value], (newStreams, oldStreams) => {
      let diffStreams = newStreams.filter(stream => !oldStreams.includes(stream));
      if(diffStreams && diffStreams.length > 0) {
       //console.log("Streams Store Add Streams for : ", diffStreams);
        window.BotServices.botEvents.StreamEvents.next({Streams : diffStreams, Action : 'Add'});
      }

      let delStreams = oldStreams.filter(stream => !newStreams.includes(stream));
      if(delStreams && delStreams.length > 0) {
        delStreams.forEach(stream => {
          if(botStore.verifyStream(stream) == -1) {
           //console.log("Streams Store Del Streams for : ", [stream]);
            window.BotServices.botEvents.StreamEvents.next({Streams : [stream], Action : 'Del'});
          }
        });
      }
    });

    /* Watch Meeting Events */
    watch(() => [...meetings.value], (newMemebers, oldMembers) => {
      let diffMeetings = newMemebers.filter(member => !oldMembers.includes(member));
      if(diffMeetings && diffMeetings.length > 0) {
       //console.log("Meeting Store Added Members : ", diffMeetings);
        diffMeetings.forEach((member) => {
           window.BotServices.botEvents.MeetingEvents.next({Member : member, Action : 'Add'});
        });
      }

      /*
      let delMeetings = oldMeetings.filter(meeting => !newMeetings.includes(meeting));
      if(delMeetings && delMeetings.length > 0) {
        delMeetings.forEach(meeting => {
          if(botStore.verifyMeeting(meeting) == -1) {
           //console.log("Meeting Store Del Meetings for : ", [meeting]);
            window.BotServices.botEvents.MeetingEvents.next({Streams : [meeting], Action : 'Del'});
          }
        });
      }*/
    });

    /* Watch attributions change */
      watch(() => [...attributions.value], () => {
        addToSessionStore({item : 'attributions'});
      });

    /* Create A New Cliet Context */
    async function regWebContext(newContexts) {
      //console.log("newContexts", JSON.stringify(newContexts));
      /*
      if(window.CommApp) {
        newContexts.forEach((context) => {
          window.CommApp.initClient(context, (err, res) =>{
           //console.log("Bot Listen To Meeting Events : ", res);
            if(res && res.command == 'initClient') {
              if(res.data && res.data.Client) {
                botStore.addClient(res.data);
              }
            } else if(res && res.command == 'initClients') {
              if(res.data && res.data.length > 0) {
                res.data.forEach((client) => {
                  botStore.addClient(client);
                });
              }
            }
          });
        });
      } else {
       //console.log("CommApp not Started Yet, still add client");
        botStore.addClient(client);
      } */
      newContexts.forEach((context) => {
        let client = createClient(context);
        botStore.addClient(client);
        setMeetingURL(client); /* Disable auto meeting creation */
      });
    }

    /* Create A New Shadow WebComponent */
    async function createWebComponent(newContainers) {
      //await nextTick();
      newContainers.forEach((container) => {
        if(container.MediaType == 'WebComponent') {
          /*
          if(container.DomHandler) {
           //console.log("DomHandler already exist for the dom : ", container.DomHandler);
            appendChild(container);
          } else {
            let domId = container.ContainerID;
            container.DomHandler = window.document.getElementById(domId).attachShadow( { mode: "open" } );
            botStore.attachShadow(container);
            appendChild(container);
          }*/
          let webCompId = container.ContainerID;
          container.DomHandler = document.getElementById(webCompId);
          appendWebComponent(container);
        } else if(container.MediaType == 'Iframe') {
          let iframeId = container.ContainerID;
          container.DomHandler = document.getElementById(iframeId);
          appendIframe(container);
        }
      });
    }

    /* Add Page To The DOM */
    function appendChild(container) {
      var getPage = new XMLHttpRequest();
      getPage.addEventListener("load", () => {
        const doc = document.createRange().createContextualFragment(getPage.responseText);
        container.DomHandler.appendChild(doc);
        window.BotServices.Events.next({Containers : [container]});
      });
      getPage.open("GET", container.URL);
      getPage.send();
    }

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
       //console.log("Observe : ", entry);
      }
      
      dynamicEl.forEach((el) => {
        //console.log('Size changed', el);
        window.BotServices.resize(el);
        calcHeight(el.termination, el.footer);
      })
    });

    /* Add WebComponenet To Page */
    function appendWebComponent(container) {
     //console.log("Add WebComponent : ", container);
      var webComponentJs = document.createElement("script");
      webComponentJs.setAttribute("type", 'module')
      webComponentJs.setAttribute("src", container.URL);
      document.getElementsByTagName("head")[0].appendChild(webComponentJs);
      let webComponent = document.createElement(container.Template);
      webComponent.id = "wc_"+container.ContainerID;
      webComponent.dataset.viewportid = container.viewportID;
      if(container.dataset) {
         for (var item in container.dataset) {
           webComponent.dataset[item] = container.dataset[item];
         }
      }
      container.DomHandler.appendChild(webComponent);
      var wcomp = document.getElementById(webComponent.id);
      var footer = document.getElementById("footer_"+container.viewportID);
      calcHeight(wcomp, footer)
      dynamicEl.push({termination : wcomp, footer : footer});
      if(footer) {
        resizeObserver.observe(footer);
      }
    }

    /* Add Page To The IFRAME */
    function appendIframe(container) {
       console.log("Add Iframe : ", container);
       var iframeElement = document.createElement("IFRAME");
       iframeElement.id = "iframe_"+container.ContainerID;
       iframeElement.dataset.viewportid = container.viewportID;
       if(container.dataset) {
          for (var item in container.dataset) {
           //console.log("Setting : ", item , "Value : ", container.dataset[item]);
            iframeElement.dataset[item] = container.dataset[item];
          }
       }
       iframeElement.src = container.URL;
       iframeElement.scrolling = "yes";
       iframeElement.frameborder = "0";
       iframeElement.style.border= "none";
       iframeElement.style.width = '100%';
       //iframeElement.style.height = '100vh';
       container.DomHandler.appendChild(iframeElement);
       var iframe = document.getElementById("iframe_"+container.ContainerID);
       var footer = document.getElementById("footer_"+container.viewportID);
       iframe.onload = function() {
          if(container.Elements && container.Elements.length > 0 ) {
            console.log("Custome Lements ", container.Elements);
            injectIntoIframe(iframe);
          }
          calcHeight(iframe, footer)
          dynamicEl.push({termination : iframe, footer : footer});
       }
       resizeObserver.observe(footer);
    }

    function calcHeight(el, footer) {
      if(el && footer) {
        let rectInfo = el.getBoundingClientRect();
        let footerInfo = footer.getBoundingClientRect();
        let availHeight = window.innerHeight;
        let acutaulHeight = window.innerHeight - rectInfo.top - footerInfo.height - 10;
        el.style.height = acutaulHeight + "px";
      }
    }

    window.addEventListener('resize', ()=>{
      dynamicEl.forEach((el) => {
        calcHeight(el.termination, el.footer);
      })
    });

    window.addEventListener('viewportOnDragEnd', ()=>{
      dynamicEl.forEach((el) => {
        calcHeight(el.termination, el.footer);
      })
    });

    /* Create A Proxy for the Commands Loaded by App's */
    function createProxy(commands) {
      commands.forEach((app) => {
        proxy[app.appId] = new Proxy(app.commands, {
          get: function(target, property, receiver) {
            if(target[property]) {
             //console.log("Found Target");
              return target[property];
            } else {
             //console.log("Not Found Target");
              return null;
            }
          }
        });
      });
    }

    /* Create Client Structure from Context */
    function createClient(context) {
      let ClienObj = {
        PK : window.LivingScript_0070.guid.generateSync(),
        Client : context.clientNodeId,
        ClientState : 'Active',
        ParentClient : context.clientNodeId,
        RootClient : context.clientNodeId,
        BrowserTab : context.browserTabId,
        Meeting : context.MeetingContext.MeetingId,
        MeetingRole : 'Moderator',
        MeetingState : 'Active',
        MeetingContext : JSON.stringify(context.MeetingContext),
        MeetingContextRoute : 'NULL',
        ParentMeeting : context.MeetingContext.MeetingParentId,
        RootMeeting : context.MeetingContext.MeetingRootId,
        HostMeeting : context.MeetingContext.MeetingRootId,
        ClientLeft : context.grantItem.GrantLeftID,
        ClientLeftRole : context.grantItem.GrantLeftR,
        ClientLeftDN : context.grantItem.GrantLeftDN,
        ClientRight : context.grantItem.GrantRightID,
        ClientRightRole : context.grantItem.GrantRightR,
        ClientRightDN : context.grantItem.GrantRightDN,
        ClientContext : JSON.stringify(context.grantItem),
        InitialContext : (context.InitialContext) ? JSON.stringify(context.InitialContext) : '{}',
        CurrentContext : JSON.stringify(context),
        LocationContext : JSON.stringify({host : window.location.host, origin : window.botStore.location.origin, hostname : window.botStore.location.hostname, href : window.botStore.location.href, port : window.botStore.location.port, protocol : window.botStore.location.protocol, hash : window.botStore.location.hash, pathname : window.botStore.location.pathname, search: window.botStore.location.search}),
        FinalContext : '{}',
        Session : window.LivingScript_0070.context.sessionId,
        Attribution : context.AttributionID,
        UserPath : 'NULL',
        AgentPath : 'NULL',
        IsLanding : context.IsLanding,
        MenuPath : context.Path,
        Lock : 1
      }

      return ClienObj;
    }

    /* Generate the Meeting URL for Client */
    function setMeetingURL(Client) {
      console.log("Settings => ", window.botStore.settings);

      let baseUrl = '';
      if(window.botStore.settings['SmartView'] == 'true') {
        baseUrl = window.botStore.location.origin + window.botStore.location.pathname + '?MeetingContext=' + Client.MeetingContext + '&window=true' + '&smartView=true';
      } else {
        baseUrl = window.botStore.location.origin + '/DeviceManager/index.html?MeetingContext=' + Client.MeetingContext + '&window=true';
      }
      
      let params = {
        method : "POST",
        type : "application/json",
        url : "/BotServices/bot/getSignedUrl",
        data : {
          URL : baseUrl,
          Component : Client.ClientRight,
          //Role : 'Client.ClientRightRole',
          Role : 'visitor',
          //URLType : 'ShortLink',
          URLType : 'SmartNumber'
        }
      };

      //console.log("Meeting Url generate", params.data.URL);
      window.BotServices.httpRequest(params, (err, signedUrl) => {
       //console.log("setMeetingURL Result : ", signedUrl);
        Client.MeetingURL = signedUrl;
      });
    }

    return { botStore, containers, proxy };
  },
  created() {
    this.botEvents.StreamEvents = new Subject();
    this.botEvents.MeetingEvents = new Subject();
    const botServicesCreated = new Event('botServicesCreated');
    window.dispatchEvent(botServicesCreated);
  },
}
</script>

<template>
  <main>
    <div class="ShadowDoms">
    </div>
  </main>
</template>
